import { Record as ImmutableRecord } from "immutable";
import type { TAuditLogAction } from "./actions.types";

export enum AuditLogEntityType {
	ACCESS_REVIEW = "accessReview",
	APPROVAL_ALGORITHM = "approvalAlgorithm",
	APPROVAL_FLOWS_WEBHOOK = "approvalFlowsWebhook",
	BUNDLE = "bundle",
	HRMS = "hrms",
	IDP = "idp",
	INTEGRATION = "integration",
	INTEGRATION_RESOURCE = "integrationResource",
	INTEGRATION_RESOURCE_ROLE = "integrationResourceRole",
	PERMISSION = "permission",
	POLICY = "policy",
	TASK = "task",
	TICKET = "ticket",
	USER = "user"
}

export type TAuditLogEntityType =
	| "accessReview"
	| "approvalAlgorithm"
	| "approvalFlowsWebhook"
	| "bundle"
	| "hrms"
	| "idp"
	| "integration"
	| "integrationResource"
	| "integrationResourceRole"
	| "permission"
	| "policy"
	| "task"
	| "ticket"
	| "user";

const defaults = {
	id: "",
	data: {} as Record<string, unknown>,
	executerUserId: "" as string | null,
	entityId: "",
	entityType: "" as AuditLogEntityType,
	createdAt: new Date(0),
	action: "" as TAuditLogAction
};

export class AuditLogModel<
	E extends AuditLogEntityType = AuditLogEntityType,
	A extends TAuditLogAction = TAuditLogAction,
	D extends Record<string, unknown> = Record<string, unknown>
> extends ImmutableRecord<typeof defaults>(defaults) {
	declare entityType: E;
	declare action: A;
	declare data: D;

	static fromServerData(recordData: unknown) {
		const { action, createdAt, data, entityId, entityType, executerUserId, id } = recordData as typeof defaults;

		return new AuditLogModel({
			id,
			createdAt: new Date(createdAt),
			data,
			entityId,
			entityType,
			executerUserId,
			action
		});
	}
}
